import { c as _c } from "react/compiler-runtime";
import { useCallback, useState } from 'react';
const timeout = 1000;
const useClipboard = () => {
  const $ = _c(4);
  const [copiedText, setCopiedText] = useState(null);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = async text => {
      ;
      try {
        await navigator.clipboard.writeText(text);
        setCopiedText(text);
        setTimeout(() => {
          setCopiedText(null);
        }, timeout);
      } catch (t1) {
        const error = t1;
        console.error("Failed to copy text:", error);
      }
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const copy = t0;
  const t1 = Boolean(copiedText);
  let t2;
  if ($[1] !== copiedText || $[2] !== t1) {
    t2 = {
      copy,
      hasCopied: t1,
      copiedText
    };
    $[1] = copiedText;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
export default useClipboard;